import { CreateMessage, CreateMessageVariables } from './__generated__/CreateMessage'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateMessage($input: CreateMessageInputV2!) {
    createMessage: createMessageV2(input: $input) {
      ... on MessageV2 {
        id
        characters
        text
      }
      ... on MessageErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreateMessage = () => {
  return useMutation<CreateMessage, CreateMessageVariables>(MUTATION)
}
